module.exports = __webpack_public_path__ + "static/media/deskbanner.e2d052c4.png";